/**
 * Shared list/table toolbar chrome: search field and compact secondary controls.
 */

export const TABLE_TOOLBAR_SEARCH_INPUT_CLASSNAME =
  "h-8 rounded-full border-gray-3 bg-white py-0 pl-8 pr-2 !shadow-none placeholder:text-gray-8 focus-visible:ring-gray-4";

/**
 * Export, Filters, and other compact triggers in the table toolbar row.
 * Structural classes only — pair with `variant="secondary" size="md"`, which
 * supply height, padding, ring, fill, text, and interaction states.
 */
export const TABLE_TOOLBAR_BUTTON_CLASSNAME =
  "group motion-reduce:transition-none";

/** Leading icons from the 18px set — Button md renders them at 16px (size-4). */
export const TABLE_TOOLBAR_LEADING_ICON_CLASSNAME =
  "shrink-0 text-icon-secondary transition-colors group-hover:text-icon-primary";

/**
 * With `@src/lib/icons/12px/chevron-down`.
 * Important sizing keeps `Button`'s SVG size variants from upscaling the chevron.
 */
export const TABLE_TOOLBAR_CHEVRON_DOWN_ICON_CLASSNAME =
  "!size-2.5 shrink-0 text-icon-secondary transition-colors group-hover:text-icon-primary";
